import { rgba } from 'polished';
import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  headerHeight: '59px',
  fonts: {
    light: 'Montserrat-Light',
    regular: 'Montserrat-Regular',
    bold: 'Montserrat-Bold',
    medium: 'Montserrat-Medium',
    semiBold: 'Montserrat-SemiBold'
  },
  colors: {
    red: '#c10230',
    lightBlue: '#009ED3',
    navyBlue: '#00386E',
    black: 'black',
    focusShadowLightBlue: rgba(0, 185, 247, 0.5), // lighten 7% and .5 opacity
    focusShadowNavyBlue: rgba(0, 56, 110, 0.5), //  .5 opacity
    hoverBackgroundLightBlue: '#008bb9', // darken 5%
    hoverBackgroundNavyBlue: '#002c56',
    hoverBorderLightBlue: '#0078a0', // darken 10%
    hoverBorderNavyBlue: '#002c56',
    white: 'white',
    inputBorderGrey: '#CCD6E2',
    backgroundGrey: '#f4f6fa',
    gray: '#E5E5E5',
    success: '#28a745',
    error: '#dc3545',
    warning: '#ffc107',
    info: '#17a2b8',
    grey: '#6c757d',
    primary: '#007bff',
    textGrey: '#6c757d',
    approvedGreen: '#00BA88'
  },
  icons: {
    diamond: '"\\e907"',
    duplicate: '"\\e90f"',
    letter: '"\\e913"',
    proof: '"\\e914"',
    greenStar: '"\\e912"',
    document: '"\\e911"',
    copy: '"\\e900"',
    magnifyGlass: '"\\e901"',
    house: '"\\e902"',
    location: '"\\e903"',
    time: '"\\e904"',
    save: '"\\e905"',
    upload: '"\\e906"',
    logout: '"\\e908"',
    pdf: '"\\e909"',
    download: '"\\e90a"',
    redo: '"\\e90b"',
    clearCache: '"\\e90c"',
    x: '"\\e90d"',
    arrow: '"\\e90e"',
    trash: '"\\e910"',
    check: '"\\e91a"',
    pencil: '"\\e920"',
    info: '"\\e958"',
    plus: '"\\e95e"',
    checkcircle: '"\\e961',
    xcircle: '"\\e962',
    certificate: '"\\e97d"',
    export: '"\\ee58"',
    preapproved: '"\\e915"'
  }
};
